import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconAngleRight, IconCheckDefault } from '@iwoca/icons';
import { Button, Pill, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const RCFOfferCard = ({
    offer,
    selectRCFOffer
}: {
    offer: TFormalOffer;
    selectRCFOffer: () => void;
}) => {
    return (
        <div className="space-y-l rounded-l bg-gradient-to-br from-primary-10 to-primary-40 p-xl">
            <div>
                <Pill variant="green">
                    <FormattedMessage
                        id="_.rcf_offer_card.pill"
                        defaultMessage="Further offer"
                    />
                </Pill>
                <h5 className="my-0 text-2xl font-bold text-structure-100">
                    <FormattedMessage
                        id="_.rcf_offer_card.title"
                        defaultMessage="Your Alternative: Flexi Credit Line"
                    />
                </h5>
                <Text
                    className="text-structure-100"
                    data-testid="rcf-offer-description"
                >
                    <FormattedMessage
                        id="_.rcf_offer_card.description"
                        defaultMessage="Instead of a one-time payout, you can also use your {offerAmount} as a flexible credit line:"
                        values={{
                            offerAmount: (
                                <FormattedCurrency
                                    value={offer.available_cash!}
                                />
                            )
                        }}
                    />
                </Text>
            </div>

            <div className="flex flex-row items-start gap-s">
                <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                <Text className="font-reg text-structure-100">
                    <FormattedMessage
                        id="_.rcf_offer_card.benefit1"
                        defaultMessage="<strong>Available at any time:</strong> set up once and flexibly withdraw money for 12 months without a new application."
                        values={{
                            strong: (chunks: string) => (
                                <strong>{chunks}</strong>
                            )
                        }}
                    />
                </Text>
            </div>
            <div className="flex flex-row items-start gap-s">
                <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                <Text className="font-reg text-structure-100">
                    <FormattedMessage
                        id="_.rcf_offer_card.benefit2"
                        defaultMessage="<strong>Lower monthly payments:</strong> pay only interest on the outstanding amount."
                        values={{
                            strong: (chunks: string) => (
                                <strong>{chunks}</strong>
                            )
                        }}
                    />
                </Text>
            </div>
            <div className="flex flex-row items-start gap-s">
                <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                <Text className="font-reg text-structure-100">
                    <FormattedMessage
                        id="_.rcf_offer_card.benefit3"
                        defaultMessage="Interest is only charged on the amount outstanding each month."
                        values={{
                            // eslint-disable-next-line formatjs/enforce-placeholders
                            strong: (chunks: string) => (
                                <strong>{chunks}</strong>
                            )
                        }}
                    />
                </Text>
            </div>
            <Button
                className="w-full"
                variant="secondary-alt"
                onClick={() => {
                    tracking.ampli.rcfOfferCardClicked();
                    selectRCFOffer();
                }}
            >
                <FormattedMessage
                    id="_.rcf_offer_card.button"
                    defaultMessage="To the Flexi credit line"
                />
                <IconAngleRight />
            </Button>
        </div>
    );
};
